import { Tooltip as MuiTooltip, TooltipProps, styled } from '@mui/material';

export const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : theme.palette.grey[800],
    color: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.87)' : '#fff',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: `1px solid ${theme.palette.mode === 'light' ? '#fafafa' : theme.palette.grey[700]}`,
    padding: '1em',
    boxShadow: '2px 3px 3px 2px rgba(0, 0, 0, .25)',
  },
}));
